import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { icons } from '../assets';
import { RestoreIcon } from '../components/icons/RestoreIcon';
import { ARCHIVE_ICON } from '../constants/assetConstants';
import { checkIfEmailIsVerifiedOrNot } from '../contexts/UserContext';
import { apiRestoreMutipleArchivedAutomation } from '../helpers/api';
import { successToast } from '../helpers/toastHelper';
import { getCuratorAutomationPath } from '../helpers/urlHelper';
import { useAutomationActions } from '../hooks/useAutomationActions';
import { paginatedAutomationActions } from '../redux/slicers/admin/paginatedAutomation';
import ThumbnailCardUI, { ACTION } from './ThumbnailCardUI';
import styles from './ThumbnailCardUI.module.scss';
import { checkIfMemberHaveEditorAccess } from '../contexts/UserContext';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { AUTOMATION_ROUTE } from '../constants/routePathConstants';
import { Mixpanel, MxEvent } from './Mixpanel';
const { InfoIcon, ArchiveIcon } = icons;

export const ThumbnailCardAutomation = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  hideFavourite,
  onEdit,
  onEditInfo,
  onDelete,
  customActions,
  designV2,
  ...rest
}) => {
  const {
    onDelete: _onDelete,
    onFavouriteToggle,
    favouriteLoading,
    downloadAutomation,
    downloadLoading,
    addToCollection,
  } = useAutomationActions({
    item: data,
  });

  const dispatch = useDispatch();

  const handleDelete = onDelete || _onDelete;
  const count = data?.template_count || 0;
  const isArchived = data?.is_archive;
  const isOldObj = data?.is_old_obj;
  let actions = {
    [ACTION.INFO]: { label: 'INFO', icon: designV2 ? InfoIcon : <InfoIcon /> },
    ...customActions,
  };

  const onRestore = async (id) => {
    var formData = new FormData();
    formData.append('id', id);

    const res = await apiRestoreMutipleArchivedAutomation(formData);

    if (res.status) {
      dispatch(paginatedAutomationActions.deleteStart({ itemId: id }));
      !res?.message && successToast('Automation restored successfully.');
      dispatch(paginatedAutomationActions.deleteSuccess({ itemId: id }));
    } else dispatch(paginatedAutomationActions.deleteFailed({ itemId: id }));
  };

  if (isArchived) {
    actions = {
      [ACTION.RESTORE]: {
        label: 'Restore',
        icon: designV2 ? RestoreIcon : <RestoreIcon />,
        onClick: onRestore,
      },
      [ACTION.RETRY]: { onClick: null },
      [ACTION.RAISE_TICKET]: { onClick: null },
      [ACTION.DOWNLOAD]: { onClick: null },
      [ACTION.EDIT]: { onClick: null },
      [ACTION.SHARE]: { onClick: null },
      [ACTION.ADD_TO_COLLECTION]: { onClick: null },
      [ACTION.DELETE]: { onClick: null },
      [ACTION.EDIT_INFO]: { onClick: null },
    };
    hideFavourite = true;
  }

  if (!actions) {
    actions = data.is_main_render
      ? {
          [ACTION.DELETE]: {
            label: 'Archive',
            icon: designV2 ? ArchiveIcon : <img src={ARCHIVE_ICON} alt="Archive" />,
          },
        }
      : undefined;
  }

  const bottomRightText = 'template_count' in data ? `Templates: ${count}` : null;
  const url = getCuratorAutomationPath('open', data?.id);

  const handleEdit = (id) => {
    if (!checkIfMemberHaveEditorAccess()) return;

    Mixpanel.track(true, MxEvent.EDIT_IN_3D_AUTOMATION, {
      automation_id: data?.id,
      automation_name: data?.name,
    });

    window.open(url, '_blank');
  };

  const titleProps = !isArchived && {
    as: Link,
    target: '_blank',
    to: url,
    onClick: (e) => {
      if (!checkIfMemberHaveEditorAccess()) {
        e.preventDefault();
        return;
      }

      Mixpanel.track(true, MxEvent.EDIT_IN_3D_AUTOMATION, {
        automation_id: data?.id,
        automation_name: data?.name,
      });
    },
  };

  return designV2 ? (
    <ThumbnailCardV2
      onFavouriteChange={onFavouriteToggle(data)}
      onSelect={onSelect}
      bottomRightText={bottomRightText}
      selected={selected}
      isFavourite={data.is_favourite}
      hideFavourite={hideFavourite}
      favouriteLoading={favouriteLoading}
      titleProps={titleProps}
      data={data}
      name={data?.name}
      thumbnail={data?.thumbnail}
      date={data?.updated_at || data.created_at}
      userCard
      showMenu
      to={!isArchived && url}
      id={data?.id}
      redirect={true}
      redirectURL={!isArchived && `${AUTOMATION_ROUTE}/${data?.id}`}
      redirectTarget="_self"
      target=""
      customActions={actions}
      showCheckbox
      isFavouriteIcon
      onEdit={handleEdit}
      onEditInfo={onEditInfo}
      onDelete={isOldObj ? null : handleDelete}
      // onDownload={downloadAutomation}
      // downloadLoading={downloadLoading}
      fullWidth={fullWidth}
      onAddToCollection={addToCollection}
      {...rest}
    />
  ) : (
    <ThumbnailCardUI
      key={data.id}
      id={data.id}
      onEdit={handleEdit}
      onEditInfo={onEditInfo}
      to={!isArchived && `/automation/${data?.id}`}
      target=""
      thumbnail={data?.thumbnail}
      name={data.name}
      isFavourite={data.is_favourite}
      favouriteLoading={favouriteLoading}
      date={data.created_at}
      onDelete={isOldObj ? null : handleDelete}
      onFavouriteChange={onFavouriteToggle(data)}
      size={size}
      titleProps={titleProps}
      // onDownload={downloadAutomation}
      // downloadLoading={downloadLoading}
      fullWidth={fullWidth}
      onSelect={onSelect}
      selected={selected}
      onAddToCollection={addToCollection}
      bottomRightText={bottomRightText}
      hideFavourite={hideFavourite}
      data={data}
      customActions={actions}
      actionsListClassName={
        isArchived ? styles.actionListSpaceAround : styles.actionListSpaceBetween
      }
      showActionsText={isArchived}
      {...rest}
    />
  );
};
